import React from "react";
import { Box } from "@mui/system";
import { Point, Area } from "react-easy-crop/types";
import { Typography } from "@mui/material";
import ImageUploading, { ImageListType } from "react-images-uploading";
import ImageCropPopUp from "../styledComponents/imageCropPopUp.component";
import ImageInput from "../styledComponents/imageInput.component";
import ImagePreview from "../styledComponents/imagePreview.component";

interface formImageUploadInputProps {
  images: never[];
  onChange: (
    imageList: ImageListType,
    addUpdateIndex: number[] | undefined
  ) => void;
  cropStatus: string;
  open: boolean;
  handleClose: () => void;
  crop: Point;
  zoom: number;
  setCrop: React.Dispatch<React.SetStateAction<Point>>;
  onCropComplete: (croppedArea: Area, croppedAreaPixels: Area) => void;
  setZoom: React.Dispatch<React.SetStateAction<number>>;
  imageSrc: string;
  subTitle?: string;
  cropWidth: number;
  cropHeight: number;
}

const FormImageUploadInput: React.FC<formImageUploadInputProps> = ({
  images,
  onChange,
  cropStatus,
  open,
  handleClose,
  crop,
  zoom,
  setCrop,
  onCropComplete,
  setZoom,
  imageSrc,
  subTitle,
  cropWidth,
  cropHeight,
}) => {
  const imageContainerBackground = imageSrc ? "#00000073" : "#DEEDFE";
  return (
    <React.Fragment>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          marginTop: "12px",
          flexDirection: "column",
        }}
      >
        {subTitle && (
          <Typography
            sx={{
              letterSpacing: "0px",
              color: "#333333;",
              opacity: 0.6,
              fontFamily: "Avenir",
              fontSize: { xs: "11px", sm: "13px", md: "15px", xl: "20px" },
              lineHeight: {
                xs: "20px",
                sm: "22px",
                md: "24px",
                xl: "27px",
              },
              marginBottom: "4px",
            }}
          >
            {subTitle}
          </Typography>
        )}
        <ImageUploading
          multiple
          value={images}
          onChange={onChange}
          maxNumber={1}
        >
          {({ imageList, onImageUpload, onImageUpdate, dragProps }) => (
            <React.Fragment>
              <button
                style={{
                  border: "none",
                  padding: "0px",
                  width: "fit-content",
                }}
                onClick={
                  images[0] && cropStatus === "Finish"
                    ? () => onImageUpdate(0)
                    : cropStatus === "Begin"
                    ? onImageUpload
                    : undefined
                }
                {...dragProps}
              >
                <Box
                  sx={{
                    width: {
                      xs: "250px",
                      sm: "274px",
                      md: "333px",
                      xl: "467px",
                    },
                    height: {
                      xs: "150px",
                      sm: "150px",
                      md: "189px",
                      xl: "246px",
                    },
                    backgroundColor: imageContainerBackground,
                    boxShadow: "0px 0px 6px #00000029",
                    border: "1px solid #2685F899",
                    borderRadius: "4px",
                    opacity: 1,
                  }}
                >
                  {images[0] ? (
                    <React.Fragment>
                      {cropStatus === "Start" && (
                        <ImageCropPopUp
                          open={open}
                          handleClose={handleClose}
                          imageList={imageList}
                          crop={crop}
                          zoom={zoom}
                          setCrop={setCrop}
                          onCropComplete={onCropComplete}
                          setZoom={setZoom}
                          onImageUpdate={onImageUpdate}
                          cropWidth={cropWidth}
                          cropHeight={cropHeight}
                        />
                      )}
                      {cropStatus === "Finish" && (
                        <ImagePreview imageSrc={imageSrc} />
                      )}
                    </React.Fragment>
                  ) : imageSrc ? (
                    <ImagePreview imageSrc={imageSrc} />
                  ) : (
                    <ImageInput />
                  )}
                </Box>
              </button>
            </React.Fragment>
          )}
        </ImageUploading>
      </Box>
    </React.Fragment>
  );
};

export default FormImageUploadInput;
